export const FEATURE_FLAG_KEYS = Object.freeze({
  WHATSAPP_BUTTON: "whatsapp-button",
  SIGN_UP_EXPECTED_LEAD_PREFILL: "aqat-new-sponsor-signup-flow",
} as const);

export type FeatureFlagKey =
  (typeof FEATURE_FLAG_KEYS)[keyof typeof FEATURE_FLAG_KEYS];
